import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import {MatIconModule} from '@angular/material/icon'; 
import {MatTooltipModule} from '@angular/material/tooltip';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { FeedsComponent } from './components/feeds/feeds.component';
import { FeedsListComponent } from './components/feeds-list/feeds-list.component';
import {MatPaginatorModule} from '@angular/material/paginator'; 
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { WebService } from './service/web.service';
import { CommonService } from './service/common.service';
import { HttpClientModule } from '@angular/common/http';
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { MatChipsModule } from "@angular/material/chips";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import {MatDialogModule, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { TechQuestionsComponent } from './components/tech-questions/tech-questions.component';
import { TechQuestionsListComponent } from './components/tech-questions-list/tech-questions-list.component';
import { JobOpeningsComponent } from './components/job-openings/job-openings.component';
import { JobOpeningsListComponent } from './components/job-openings-list/job-openings-list.component';
import { ToastrModule } from 'ngx-toastr';
import { MessageService } from './service/messageService';
import {MatTableModule} from '@angular/material/table'; 
import {MatSelectModule} from '@angular/material/select';

import {
  NgxUiLoaderModule,
  NgxUiLoaderConfig,
  SPINNER,
  POSITION,
  PB_DIRECTION,
  NgxUiLoaderRouterModule,
  NgxUiLoaderHttpModule
} from 'ngx-ui-loader';
import { LoaderService } from './service/loaderService';
import { DashboardBaseComponent } from './components/dashboard-base/dashboard-base.component';
import { DashboardViewOneComponent } from './components/dashboard-view-one/dashboard-view-one.component';
import { DashboardViewTwoComponent } from './components/dashboard-view-two/dashboard-view-two.component';
import { PopoverModule } from "ngx-smart-popover";
import { LoginPopupComponent } from './components/login-popup/login-popup.component';
import { ConfirmationDialogComponent } from './components/confirmation-dialog/confirmation-dialog.component';
import { HomePageComponent } from './components/home-page/home-page.component';
import { DashboardBaseTwoComponent } from './components/dashboard-base-two/dashboard-base-two.component';
import { ForgetPasswordComponent } from './components/forget-password/forget-password.component';
import { AboutUsComponent } from './components/about-us/about-us.component';
import { UsersListComponent } from './components/users-list/users-list.component';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { ContactUsComponent } from './components/contact-us/contact-us.component'

const ngxUiLoaderConfig: NgxUiLoaderConfig = {
  bgsColor: 'red',
  // bgsOpacity: 0.5,
  // bgsPosition: POSITION.bottomLeft,
  // bgsSize: 60,
  // bgsType: SPINNER.chasingDots,
  // blur: 5,
  // delay: 0,
  fastFadeOut: true,
  fgsColor: 'red',
  // fgsPosition: POSITION.centerCenter,
  // fgsSize: 60,
  // fgsType: SPINNER.chasingDots,
  // gap: 24,
  // logoPosition: POSITION.centerCenter,
  // logoSize: 120,
  // logoUrl: 'assets/angular.png',
  // overlayBorderRadius: '0',
  // overlayColor: 'rgba(40, 40, 40, 0.8)',
  pbColor: 'red'
  // pbDirection: PB_DIRECTION.leftToRight,
  // pbThickness: 5,
  // hasProgressBar: false,
  // text: 'Welcome to ngx-ui-loader',
  // textColor: '#FFFFFF',
  // textPosition: POSITION.centerCenter,
  // maxTime: -1,
  // minTime: 500
};


@NgModule({
  declarations: [
    AppComponent,
    FeedsComponent,
    FeedsListComponent,
    TechQuestionsComponent,
    TechQuestionsListComponent,
    JobOpeningsComponent,
    JobOpeningsListComponent,
    DashboardBaseComponent,
    DashboardViewOneComponent,
    DashboardViewTwoComponent,
    LoginPopupComponent,
    ConfirmationDialogComponent,
    HomePageComponent,
    DashboardBaseTwoComponent,
    ForgetPasswordComponent,
    AboutUsComponent,
    ContactUsComponent,
    UsersListComponent,
    ContactUsComponent
  ],
  imports: [
    BrowserModule,
    MatIconModule,
    MatTooltipModule,
    MatPaginatorModule,
    MatSlideToggleModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    MatAutocompleteModule,
    MatChipsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    AppRoutingModule,
    HttpClientModule,
    ToastrModule.forRoot(),
    NgxUiLoaderModule.forRoot(ngxUiLoaderConfig),
    NgxUiLoaderRouterModule, // import this module for showing loader automatically when navigating between app routes
    NgxUiLoaderHttpModule,
    PopoverModule,
    MatTableModule,
    MatDialogModule
  ],
  providers: [
    CommonService,
    WebService,
    MessageService,
    LoaderService,
    { provide: MAT_DIALOG_DATA, useValue: {} },
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
